<template>
  <b-form class="mt-3">
    <b-row v-if="props.mode == 'List'">
      <b-col cols="12" md="3">
        <b-form-group label="ชุดอนุกรรมการ" label-for="groupSelect">
          <vue-select
            label="name"
            value="id"
            v-model="groupSelect"
            :options="groupOptions"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="3">
        <b-form-group label="สถานะจดหมายเชิญ" label-for="statusSelect">
          <vue-select
            label="name"
            value="id"
            v-model="statusSelect"
            :options="statusOptions"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <InputFilter :filter="search[3]" />
      </b-col>
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        @click="onSearchBtnClicked"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // const options = [
    //   { text: 'ทั้งหมด', value: null },
    //   { text: 'ใช้งาน', value: true },
    //   { text: 'ไม่ใช้งาน', value: false },
    // ]
    const options = [
      { label: "ทั้งหมด", code: null },
      { label: "ใช้งาน", code: true },
      { label: "ไม่ใช้งาน", code: false },
    ];

    const searchList = [
      {
        id: "directorGroupId",
        label: "ชุดอนุกรรมการ",
        value: "",
        class: "",
        style: "",
        placeholder: "คำค้นหา",
        type: "select",
        options: [],
      },
      {
        id: "committeeStatus",
        label: "สถานะจดหมายเชิญ",
        value: "",
        class: "",
        style: "",
        placeholder: "สถานะจดหมายเชิญ",
        type: "select",
        options: [],
      },
       {
        id: "startdateSearch",
        label: "วันที่เริ่มต้น",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      props,
    };
  },
  data() {
    return {
      groupOptions: [],
      groupSelect: {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      },
      statusOptions: [
        { name: "ทั้งหมด", id: null },
        { name: "รอสร้างจดหมายเชิญ", id: 999},
        { name: "รอการอนุมัติ", id: 1 },
        { name: "อนุมัติ", id: 2 },
      ],
      statusSelect: {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      },
    };
  },
  mounted() {
    this.getDirectorGroup();
  },
  methods: {
    onResetBtnClicked() {
      // this.search[0].value = null;
      // this.search[1].value = null;
      this.groupSelect = {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      };
      this.statusSelect = {
        id: null,
        name: "กรุณาเลือกข้อมูล",
      };
      this.search[2].value=null
      this.search[3].value=null
      //  this.search[4].value=null
      //  this.search[5].value=null
    },
    onSearchBtnClicked() {
      const params = {
        directorGroupId: this.groupSelect?.id,
        committeeStatus: this.statusSelect?.id,
        startDate: this.search[2].value,
        endDate: this.search[3].value,
      };

      //console.log('onSearchBtnClicked', params)

      this.$emit("handleSubmit", params);
    },
    getDirectorGroup() {
      const _this = this;
      mediateDirectorGroupStore.search({ isActive: true }).then((response) => {
        //console.log("getDirectorGroup response =>", response.data.data);
        _this.groupOptions = response.data.data;
      });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
